import { useForm } from 'react-hook-form'

import { ButtonRoundedSm, CheckboxInputSM, InputSM } from '@apps-common/components/elements'
import {
  ModalBody,
  ModalCloseButton,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalHeaderContainer
} from '@apps-common/components/modals/modal'
import { MESSAGE_IS_MM_ADMIN } from '@apps-common/config/app-messages'
import { ModalDismiss } from '@apps-common/config/modal'
import { FORM_DEFAULT_REQUIRED } from '@apps-common/config/react-hook-form'
import { IMyMonitoringAccountUnitItemModel } from '@apps-common/types/portal/my-monitoring'

export const MyMonitoringUnitAddModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IMyMonitoringAccountUnitItemModel
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<IMyMonitoringAccountUnitItemModel>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: componentProps
  })

  const submit = (values: IMyMonitoringAccountUnitItemModel) => {
    if (values.userPartition && values.userPartition.length > 0) {
      values.mapPartition = true
    }

    onDismiss(JSON.stringify(values), ModalDismiss.Confirm)
  }

  return (
    <ModalContainer innerClasses='sm:!min-h-0 !h-auto sm:!max-w-[450px]'>
      <ModalHeaderContainer>
        <div className='flex items-start justify-between'>
          <ModalHeader subtitle='Update' title='User device' />
          <ModalCloseButton closeModal={() => onDismiss(ModalDismiss.Cancel)} />
        </div>
      </ModalHeaderContainer>
      <ModalBody classes='!pt-[100px]'>
        <form id='my-monitoring-user-device-add-form' noValidate onSubmit={handleSubmit(submit)}>
          <InputSM
            key='userNumber'
            type='text'
            placeholder='1 to 999'
            label='User number (Zone)'
            id='userNumber'
            showLabel
            registration={register('userNumber', {
              required: FORM_DEFAULT_REQUIRED,
              pattern: {
                value: /^[0-9]{3}$/,
                message: '3 numerical characters only e.g. 001'
              }
            })}
            errors={errors.userNumber}
          />
          <InputSM
            key='userPartition'
            type='text'
            placeholder='0 to 99'
            label='User partition (If required)'
            id='userPartition'
            showLabel
            registration={register('userPartition', {
              required: false,
              pattern: {
                value: /^[0-9]{2}$/,
                message: '2 numerical characters only e.g. 01'
              }
            })}
            errors={errors.userPartition}
          />
          <CheckboxInputSM
            label='Site administrator'
            id='isAdmin'
            registration={register('isAdmin')}
            errors={errors.isAdmin}
            info={MESSAGE_IS_MM_ADMIN}
          />
        </form>
      </ModalBody>
      <ModalFooter>
        <ButtonRoundedSm type='submit' form='my-monitoring-user-device-add-form' loading={false} text='Add' className='action-success' />
      </ModalFooter>
    </ModalContainer>
  )
}
